import type { SearchAvailableParams } from "./types";

export const phoneNumberKeys = {
  all: ["PHONE_NUMBERS"] as const,
  lists: () => [...phoneNumberKeys.all, "LIST"] as const,
  aiAgentNumbers: () =>
    [...phoneNumberKeys.lists(), "AI_AGENT_NUMBERS"] as const,
  withRecipients: (ids: number[]) =>
    [...phoneNumberKeys.lists(), "WITH_RECIPIENTS", ids] as const,
  ringingUsers: (phoneNumberId: number) =>
    [...phoneNumberKeys.all, "RINGING_USERS", phoneNumberId] as const,
  searchAvailable: (params: SearchAvailableParams) =>
    [...phoneNumberKeys.all, "SEARCH_AVAILABLE", params] as const,
  propertyDefaults: () =>
    [...phoneNumberKeys.all, "PROPERTY_DEFAULTS"] as const,
  propertyDefault: (propertyId: number) =>
    [...phoneNumberKeys.all, "PROPERTY_DEFAULT", propertyId] as const,
  leasingAgents: () => ["LEASING_AGENTS"] as const
};
